export default "__VITE_ASSET__484eea2b__"